<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">Liste yükleniyor</div>
							</div>
						</template>
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details prepend-inner-icon="search" v-model="filterText" label="Ara"></v-text-field>
								<v-btn icon @click="editItem()">
									<v-icon>add_circle</v-icon>
								</v-btn>
							</v-toolbar>
  
							<v-list >
								<template v-for="(item, itemIndex) in getItems"> 
									<v-list-tile :key="itemIndex" avatar @click="editItem(item)" >  
										<v-list-tile-content>
											<v-list-tile-title> {{item.name}} </v-list-tile-title>  
										</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>

 

				<v-dialog v-model="dialogEditor"   max-width="600px">
					<v-card>
						<v-card-title>
							<span class="headline" v-if="item.id">Düzenle</span>
							<span class="headline" v-if="!item.id">Yeni Ekle</span>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-md>
								<v-layout wrap>
									<v-flex xs12>
										<v-text-field label="Token" v-model="item.token" readonly disabled></v-text-field>
									</v-flex> 
									<v-flex xs12>
										<v-text-field label="Hesap Adı" v-model="item.name"></v-text-field>
									</v-flex> 
									<v-flex xs12>
										<v-text-field label="SMS Başlığı" v-model="item.title"></v-text-field>
									</v-flex> 
									<v-flex xs12>
										<v-text-field label="Balance" v-model="item.balance" type="number"></v-text-field>
									</v-flex> 
									<v-flex xs12>
										<div class="ServiceSmsHistoryList">
											<table>
												<thead>
													<tr>
														<th>Tarih</th>
														<th>Adet</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(his,hisIndex) in item.history" :key="'his_'+hisIndex">
														<td>{{his.date}}</td> 
														<td>{{his.count}}</td> 
													</tr>
												</tbody>
											</table>
										</div>
									</v-flex> 
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions class="pr-4 pl-4 pb-4">
							<v-btn color="error" round outline v-if="item.id" @click="askForRemove()">Sil</v-btn>
							<v-spacer></v-spacer>
							<v-btn color="warning" round outline @click="closeItem()">İptal</v-btn>
							<v-btn color="success" round outline @click="saveItem()">Kaydet</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-dialog v-model="dialogRemove" persistent  max-width="290">
					<v-card> 
						<v-card-text color="error"> Silmek itediğine emin misin ? </v-card-text> 
						<v-card-actions> 
							<v-btn color="green darken-1" flat="flat" @click="closeForRemove()"> Vazgeç </v-btn> 
							<v-spacer></v-spacer>
							<v-btn color="error darken-1" flat="flat" @click="removeItem()"> EMİNİM </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>



			</v-layout>
		</v-container>
	</v-content>


</template>


<script> 
	export default {
		name: "ServicesSmsIndex",
		components : { 
		},
		data() {
			return {
				isLoading : true, 
				dialogEditor: false,
				dialogRemove: false,
				filterText : "", 
				items : [],
				item: {}
				 
			}
		},
		mounted(){
			this.loadItems();
		},
		methods : {
			loadItems(){
				this.isLoading = true; 
				this.$http.get( process.env.VUE_APP_API_URL + "/services/sms/", {
					params : { }
				}).then(response => {  
					this.items = response.body;
					this.isLoading = false; 
				}) 
			},
			editItem(item) {
				if (item) {
					this.item = JSON.parse(JSON.stringify(item))
				} else {
					this.item = {
						id: "",
						name: "",
						title: "",
						token : "",
						balance : 0,
						history : []
					}
				}
				this.dialogEditor = true;
			},
			closeItem(e) { if (e) { this.loadAccounts(); } this.dialogEditor = false },
			askForRemove() { this.dialogEditor = false; this.dialogRemove = true },
			closeForRemove() { this.dialogEditor = true; this.dialogRemove = false },
			saveItem(){
				this.dialogEditor = false;
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/services/sms/save", this.item, {
					params: { }
				}).then(response => { 
					this.loadItems();
				})
			},
			removeItem(){
				this.dialogEditor = false;
				this.dialogRemove = false;
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/services/sms/remove", this.item, {
					params: { }
				}).then(response => { 
					this.loadItems();
				})
			},
		},
		computed : { 
			getItems(){
				var items = [];
				var filterText = this.filterText.toLowerCase(); 
				items = this.items.filter( function(item) { 
					if( filterText != ""){
						if( item.name.indexOf(filterText) < 0 ){ return false; }
					}
					return true;
				})  
				items.sort(function(a, b) {
					var nameA = a.name.toUpperCase(); 
					var nameB = b.name.toUpperCase(); 
					if (nameA < nameB) { return -1; }
					if (nameA > nameB) { return 1; } 
					return 0;
				});
				return items;
			}
		}
	}
</script>


<style lang="less">
	.ServiceSmsHistoryList{
		height:200px;
		overflow-y: scroll;
		table{
			border-collapse: collapse;
    		border-spacing: 0;
			width:100%;
			thead,tbody{
				th,td{
					line-height: 30px;
					border-bottom:1px solid #ccc;
					&:first-child{text-align: left; padding-left:0px;}
					&:last-child{text-align: right; padding-right:10px;}
				}
			} 
		}
	}
</style>
